export default "__VITE_PUBLIC_ASSET__35d73350__"